import ChatAltIcon from '@heroicons/react/outline/ChatAltIcon'
import clsx from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { analyticsNumberFormatter } from '@tribeplatform/react-components/Analytics/utils'

interface Props {
  post: Post
  highlighted: boolean
  stretchX: string
}
export const ReplyCount = ({ post, highlighted, stretchX }: Props) => {
  return (
    <div
      className={clsx(
        'flex space-s-2 text-content-subdued items-center',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
    >
      <ChatAltIcon className="h-5 w-5" />
      <span>{analyticsNumberFormatter(post?.totalRepliesCount ?? '0')}</span>
    </div>
  )
}
